import { useState, useEffect } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { BottomModal } from '../shared/BottomModal';
import { TopUpPanel } from './TopUpPanel';
import { GiftsList } from './GiftList';
import { apiGifts } from '../../api/apiGifts.api';
import { toast } from 'react-toastify';

function SendGiftsModal({ isOpen, onClose, renderTitle, onSend }) {
  const axiosPrivate = useAxiosPrivate();

  const [option, setOption] = useState(1);
  const [userCoins, setUserCoins] = useState(0);

  const [presents, setPresents] = useState([]);
  const [myPresents, setMyPresents] = useState([]);
  console.log(myPresents, 'myPresents');

  const [isLoading, setIsLoading] = useState(false);
  const [loadingGifts, setLoadingGifts] = useState(false);

  const fetchUserBalance = async () => {
    try {
      const response = await axiosPrivate.get(`/users/me`);
      setUserCoins(response.data.data.wallet.coins || 0);
    } catch (error) {
      console.error('Ошибка при загрузке баланса:', error);
    }
  };

  // Загрузка баланса пользователя и подарков
  useEffect(() => {
    fetchUserBalance();

    apiGifts.fetchGifts(axiosPrivate, setLoadingGifts).then(setPresents);
    apiGifts
      .fetchMyGifts(axiosPrivate, setLoadingGifts)
      .then((gifts) => setMyPresents(gifts.filter((gift) => gift.isBought)));
  }, []);

  const handleSendGift = async (gift) => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      const existingGifts = myPresents.find((g) => g._id === gift._id && g.isBought);

      if (!existingGifts) {
        await axiosPrivate.post('/gifts/buy', {
          giftId: gift._id
        });
      }
      await onSend(gift._id);
      fetchUserBalance();
      apiGifts
        .fetchMyGifts(axiosPrivate, setLoadingGifts)
        .then((gifts) => setMyPresents(gifts.filter((gift) => gift.isBought)));
    } catch (error) {
      console.error('Ошибка при отправке подарка:', error);
      toast.error(error.response?.data?.message || 'Ошибка при отправке подарка');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BottomModal isOpen={isOpen} onClose={onClose}>
      <>
        <div className="px-6 pb-4 flex-shrink-0">{renderTitle()}</div>

        <div className="px-6 pb-4 flex-shrink-0">
          <div className="flex flex-row h-[44px] bg-white/10 rounded-[12px] p-1">
            <button
              className={`flex-1 flex items-center justify-center rounded-[8px] text-[14px] font-medium transition-all duration-200 ${
                option === 1 ? 'bg-white/15 text-[#A1F69E] shadow-lg' : 'text-white/70 hover:text-white'
              }`}
              onClick={() => setOption(1)}
            >
              Магазин подарков
            </button>
            <button
              className={`flex-1 flex items-center justify-center rounded-[8px] text-[14px] font-medium transition-all duration-200 ${
                option === 2 ? 'bg-white/15 text-[#A1F69E] shadow-lg' : 'text-white/70 hover:text-white'
              }`}
              onClick={() => setOption(2)}
            >
              Купленные подарки
            </button>
          </div>
        </div>

        <div
          className="flex-1 overflow-y-auto mt-2 px-4 min-h-[200px]"
          style={{
            WebkitOverflowScrolling: 'touch',
            overscrollBehavior: 'contain'
          }}
        >
          <GiftsList
            gifts={option === 1 ? presents : myPresents}
            loading={loadingGifts}
            renderAction={(item, isSelected) => {
              return (
                isSelected && (
                  <button
                    className="absolute bottom-0 left-0 right-0 h-[29px] bg-[#A1F69E] flex items-center justify-center transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSendGift(item);
                    }}
                    disabled={isLoading}
                  >
                    <span className="text-[#010D0D] text-[13px] font-bold">
                      {isLoading ? 'Отправка...' : 'Отправить'}
                    </span>
                  </button>
                )
              );
            }}
            renderNotGifts={() => {
              return option === 1 ? (
                <div className="flex flex-col items-center justify-center py-12">
                  <div className="text-[48px] mb-4">🎁</div>
                  <p className="text-white/60 text-[16px] text-center font-raleway">Подарки временно недоступны</p>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-12">
                  <div className="text-[48px] mb-4">🎁</div>
                  <p className="text-white/60 text-[16px] text-center font-raleway">
                    У вас пока нет купленных подарков
                  </p>
                </div>
              );
            }}
          />
        </div>

        <TopUpPanel userCoins={userCoins} />
      </>
    </BottomModal>
  );
}

export default SendGiftsModal;
